
import { defineComponent } from 'vue';
import SvgRedTag from '@/components/Icons/SvgRedTag.vue';

export default defineComponent({
    name: 'VirtualRedTagHeader',
    components: {
        SvgRedTag,
    },
    props: {
        // The header as drawn in the Figma notification frames: an outlined tag
        // icon and a lighter title, on a 58px bar.
        outlined: {
            type: Boolean,
            default: false,
        },
    },
});
